import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MatrixRain from './components/MatrixRain';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogAdmin from './pages/BlogAdmin';

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center pt-20">
    <div className="terminal-window max-w-md glow-green">
      <div className="terminal-header">
        <div className="terminal-dot bg-cyber-red"></div>
        <div className="terminal-dot bg-cyber-amber"></div>
        <div className="terminal-dot bg-cyber-green"></div>
        <span className="ml-3 text-xs text-cyber-muted">error</span>
      </div>
      <div className="terminal-body text-center py-10">
        <p className="text-6xl font-bold text-cyber-red mb-4">404</p>
        <p className="text-cyber-green font-mono mb-2">$ cat /dev/null</p>
        <p className="text-cyber-muted mb-6">The requested resource was not found on this server.</p>
        <a href="/" className="inline-block px-6 py-2 bg-cyber-green text-cyber-black font-bold rounded hover:bg-cyber-cyan transition-colors">
          {'>'} Return to Base
        </a>
      </div>
    </div>
  </div>
);

const App = () => {
  return (
    <Router>
      <div className="bg-cyber-black text-cyber-text min-h-screen font-mono scanline-overlay noise-overlay relative">
        <MatrixRain opacity={0.04} />
        <div className="relative z-10 bg-cyber-grid min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/admin" element={<BlogAdmin />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </Router>
  );
};

export default App;
